import { useRef } from 'react';
import styled from 'styled-components';
import type { MediaImageProps } from '@elfsight/widget-media';
import { MediaImage as MediaImageComponent } from '@elfsight/widget-media';

function _MediaImage({
  src,
  ratio,
  backgroundColor,
  alt = '',
  ...forwardingProps
}: MediaImageProps) {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <MediaImageComponent
      {...forwardingProps}
      ref={ref}
      withSkeleton
      skeletonBorderRadius={0}
      alt={alt}
      src={src}
      ratio={ratio}
      backgroundColor={backgroundColor}
    />
  );
}

export const MediaImage = styled(_MediaImage)``;
